import {VisualPatternInterface} from './visual-pattern.interface';

export interface ImagePatternInterface extends VisualPatternInterface {
    base64: string;
}
